// extracted by mini-css-extract-plugin
export default {"button-wrapper":"ButtonWrapper_button-wrapper__YQyJN","right":"ButtonWrapper_right__cNtOY","left":"ButtonWrapper_left__nW19n","center":"ButtonWrapper_center__KnmF+"};